import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Title from '../scenes/Title';
import UIAssetKeys from '../UIAssetKeys';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Spelly extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Title} scene 
   * @param {string} type
   */
  constructor(scene, type) {
    super(scene);

    this.scene = scene;
    this.type = type;

    this.cont = null;

    this.body = null;
    this.beak = null;
    this.lArm = null;
    this.rArm = null;

    this.wingTween = null;
    this.beakTween = null;

    this.lArmTween = null;
    this.rArmTween = null;

    this.setup();
  }

  setup () {
    this.createSpelly();
  }

  createSpelly () {
    this.cont = this.scene.add.container();
    this.add(this.cont);

    if (this.type === 'cockpit') {
      this.rArm = ABCyaPhaser.Images.addImage(0, -90, UIAssetKeys._1_Welcome_and_Level_Screen_Spelly_WingCtrlBkgd, this.cont).setOrigin(0.1);
    }
    else {
      this.rArm = ABCyaPhaser.Images.addImage(20, -90, UIAssetKeys._1_Welcome_and_Level_Screen_Spelly_WingWave, this.cont).setOrigin(0.1, 0.9)
        .setAngle(-60);
    }

    this.body = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._1_Welcome_and_Level_Screen_Spelly_Torso, this.cont).setOrigin(0.5, 1);

    this.beak = ABCyaPhaser.Images.addImage(0, -120, UIAssetKeys._1_Welcome_and_Level_Screen_Spelly_Beak, this.cont).setOrigin(0.1, 0.9)
      .setAngle(-10);


    if (this.type === 'cockpit') {
      this.lArm = ABCyaPhaser.Images.addImage(-30, -85, UIAssetKeys._1_Welcome_and_Level_Screen_Spelly_WingCtrlFrgd, this.cont).setOrigin(0.1);
    }
    else {
      this.lArm = ABCyaPhaser.Images.addImage(-30, -85, UIAssetKeys._1_Welcome_and_Level_Screen_Spelly_WingHatch, this.cont).setOrigin(0.9)
        .setAngle(60);
    }
  }

  openHatch () {
    ABCyaPhaser.Tweens.addTween(this.lArm, 1000, { angle: -10 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.rArm, 1000, { angle: 0 }, Phaser.Math.Easing.Quadratic.Out, () => this.waveArm());
  }

  waveArm () {
    this.wingTween = ABCyaPhaser.Tweens.addTween(this.rArm, 2000, { angle: 25, yoyo: true, repeat: -1 },Phaser.Math.Easing.Quadratic.InOut);
  }

  exitCockpit () {
    ABCyaPhaser.Tweens.addTween(this.lArm, 750, { angle: 60 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.rArm, 750, { angle: 60 }, Phaser.Math.Easing.Quadratic.Out, () => this.swapAndLeave());
  }

  swapAndLeave () {
    this.cont.scaleX = -1;
    ABCyaPhaser.Tweens.addTween(this.cont, 1000, { x: -175 }, Phaser.Math.Easing.Quadratic.Out, () => this.scene.createSpelly(false));
  }

  closeHatch () {
    this.scene.tweens.killTweensOf(this.rArm);
    this.scene.tweens.killTweensOf(this.wingTween);

    ABCyaPhaser.Tweens.addTween(this.lArm, 1000, { angle: 60, delay: 500 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.rArm, 1000, { angle: -60, delay: 500 }, Phaser.Math.Easing.Quadratic.Out);
  }

  enterCockpit () {
    ABCyaPhaser.Tweens.addTween(this.lArm, 750, { angle: 0 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.rArm, 750, { angle: 0 }, Phaser.Math.Easing.Quadratic.Out);
  }

  speak (type) {
    if (type === 'select') {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._Select_A_Level, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

      this.beakTween = ABCyaPhaser.Tweens.addTween(this.beak, 100, { angle: 0, yoyo: true, repeat: 7 }, Phaser.Math.Easing.Quadratic.InOut);
    }
  }

  moveLight (randTime, randDel) {
    console.log('move spelly light');
    this.lArmTween = ABCyaPhaser.Tweens.addTween(this.lArm, randTime, { x: -10, delay: randDel, yoyo: true, hold: randDel }, Phaser.Math.Easing.Quadratic.Out);

    this.rArmTween = ABCyaPhaser.Tweens.addTween(this.rArm, randTime, { x: -30, delay: randDel, yoyo: true, hold: randDel }, Phaser.Math.Easing.Quadratic.Out);
  }

  cleanUp () {
    console.log('cleaning up spelly');
    this.scene.tweens.killTweensOf(this.rArm);
    this.scene.tweens.killTweensOf(this.lArm);
    this.scene.tweens.killTweensOf(this.beak);

    this.wingTween?.stop();
    this.beakTween?.stop();

    this.lArmTween?.stop();
    this.rArmTween?.stop();

    this.body.destroy();
    this.rArm.destroy();
    this.lArm.destroy();
    this.beak.destroy();
    this.cont.destroy();
  }
}